/**
 * Defines Slack OAuth State interface
 * */

import { NotificationsPermissionsGroup} from "../projects/types";

export interface SlackOAuthState {
    httpInProgress: boolean;
    httpUpdateInProgress: boolean;
    httpError: string;
}
      
/**
 * * Defines SlackOAuth actions names
 * */
export const SLACKOAUTH_IN_PROGRESS = 'SLACKOAUTH_IN_PROGRESS'
export const SLACKOAUTH_UPDATE_IN_PROGRESS = 'SLACKOAUTH_UPDATE_IN_PROGRESS'
export const SLACKOAUTH_ERROR = 'SLACKOAUTH_ERROR'
export const SLACKOAUTH_SUCCESS = 'SLACKOAUTH_SUCCESS'
      
/**
 * * Defines SlackOAuth actions interfaces
 * */

interface SlackOauthInProgressAction {
    type: typeof SLACKOAUTH_IN_PROGRESS;
}

interface SlackOauthUpdateInProgressAction {
    type: typeof SLACKOAUTH_UPDATE_IN_PROGRESS;
}

interface SlackOauthErrorAction {
    type: typeof SLACKOAUTH_ERROR;
    error: string;
}

interface SlackOauthSuccessAction {
    type: typeof SLACKOAUTH_SUCCESS;
}
  
/**
 * * Defines all suported actions for SlackOAuth
 * */
  
export type SlackOAuthActionTypes =
    SlackOauthInProgressAction |
    SlackOauthUpdateInProgressAction |
    SlackOauthErrorAction |
    SlackOauthSuccessAction
  
/**
 * * Defines AuthActionsInterface
 * */
  
export interface SlackOAuthActionsInterface {
    slackOAuthAssign: (projectID: string, slackOAuthCode: string, slackOAuthRedirectURI: string) => void;
    slackRevokeProject: (projectID: string) => void;
    slackUpdatePermissions: (projectID: string, permissions: NotificationsPermissionsGroup) => void;
}